import { Types } from 'cafe-utility';
import { http } from "../utils/http.js";
import { Reference } from "../utils/typed-bytes.js";
const stewardshipEndpoint = 'stewardship';
/**
 * Reupload locally pinned data
 * @param requestOptions Options for making requests
 * @param reference
 * @throws BeeResponseError if not locally pinned or invalid data
 */
export async function reupload(requestOptions, stamp, reference) {
  await http(requestOptions, {
    method: 'put',
    url: `${stewardshipEndpoint}/${reference}`,
    headers: {
      'swarm-postage-batch-id': stamp.toHex()
    }
  });
}
export async function isRetrievable(requestOptions, reference) {
  reference = new Reference(reference);
  const response = await http(requestOptions, {
    method: 'get',
    responseType: 'json',
    url: `${stewardshipEndpoint}/${reference}`
  });
  const body = Types.asObject(response.data, {
    name: 'response.data'
  });
  return Types.asBoolean(body.isRetrievable, {
    name: 'isRetrievable'
  });
}